import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {DownloadsComponent} from "./downloads.component";

const routes: Routes = [
    {path: 'brochure', component: DownloadsComponent, data: {title: 'Brochure'}},
    {path: 'registration-form', component: DownloadsComponent, data: {title: 'Registration Form'}},
    {path: 'migration-policy', component: DownloadsComponent, data: {title: 'Migration Policy'}},
    {path: 'sops', component: DownloadsComponent, data: {title: 'SOPs'}},
    {path: 'guidelines', component: DownloadsComponent, data: {title: 'Guidelines'}},
    {path: 'academic-progression-rule', component: DownloadsComponent, data: {title: 'Academic Progression Rule'}},
    {path: 'newsletter', component: DownloadsComponent, data: {title: 'Newsletter'}},
    {path: 'the-arnins', component: DownloadsComponent, data: {title: 'The ARNIANS'}},
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class DownloadsRoutingModule {
}
